import { render } from "./MainNavigation.vue?vue&type=template&id=c5e56f46&scoped=true&ts=true"
import script from "./MainNavigation.vue?vue&type=script&lang=ts"
export * from "./MainNavigation.vue?vue&type=script&lang=ts"

import "./MainNavigation.vue?vue&type=style&index=0&id=c5e56f46&lang=scss&scoped=true"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5e56f46"],['__file',"src/components/MainNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5e56f46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5e56f46', __exports__)) {
    api.reload('c5e56f46', __exports__)
  }
  
  module.hot.accept("./MainNavigation.vue?vue&type=template&id=c5e56f46&scoped=true&ts=true", () => {
    api.rerender('c5e56f46', render)
  })

}


export default __exports__